
import { Component, Mixins } from "vue-property-decorator";
import { AbstractPlainTextItem, AbstractOptionSelectableTextItem, instanceOfITextValidatable, ITextLengthValidatable, IItem } from "../../../../../domain/document/items";
import { TextValidator } from "../../../../../domain/document/validators";
import { BrowserUtility, BrowserKinds } from "../../../../../utilities";
import { DataValidationKinds } from "../../../../../domain/document/DataValidationKinds";

@Component
export default class DataValidatableMixin extends Mixins() {
  editingSource: IItem;

  get shouldUseImelessTextarea(): boolean {
    if ((BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) || BrowserUtility.isMobile()) {
      return false;
    }
    if (!instanceOfITextValidatable(this.editingSource)) {
      return false;
    }
    switch (this.editingSource.dataValidationKind) {
      case DataValidationKinds.HalfNumber:
      case DataValidationKinds.AlphabetNumber:
        return true;
      default:
        return false;
    }
  }

  validateText(item: AbstractPlainTextItem | AbstractOptionSelectableTextItem, value: string): string {
    const clone = item.clone();
    if (clone instanceof AbstractOptionSelectableTextItem) {
      clone.label = value;
    } else if (clone instanceof AbstractPlainTextItem) {
      clone.value = value;
    }
    if (instanceOfITextValidatable(clone)) {
      const textValidator = new TextValidator();
      const alert = textValidator.validateCharacter(clone, 0);  // 本来itemSetIdの指定が必要だが使わないので0固定.
      if (alert) {
        // ダイアログ表示はするがawaitしないで処理抜けているので注意
        this.showAlert(alert.description, "入力規則");
        return item.text();
      }
    }
    return value;
  }

  private async showAlert(message: string, title: string): Promise<void> {
    await this.$commonDialogs.confirmation.show({
      title: title,
      message: [
        message,
      ],
      buttons: [
        {
          kind: "normal",
          label: "OK",
        },
      ],
      cancellation: {
        isEnable: false,
      },
    });
  }

  appendLengthDescription(title: string = "", item: ITextLengthValidatable): string {
    if (!item.lengthChecklength) { return title; }
    try {
      const length = item.getTextLength();
      const description = "（文字数：" + length + " / " + item.lengthChecklength + "）";
      return title + description;
    } catch {
      return title;
    }
  }
}
